/* Example events array.
   Later you can fetch from a CMS or Google Sheet, but start simple. */

export const events = [
  {
    id: 1,
    title_en: "Inclusive Classroom Masterclass",
    title_ar: "ورشة الفصول الشاملة",
    date: "2025-08-12",
    location_en: "Dubai, UAE (Hybrid)",
    location_ar: "دبي، الإمارات (وجاهي/عن بُعد)",
    desc_en:
      "A full-day workshop giving teachers hands-on tools for Universal Design for Learning.",
    desc_ar:
      "ورشة عمل ليوم كامل تُزوّد المعلمين بأدوات عملية لتصميم عالمي للتعلم.",
    registerLink: "https://bit.ly/udl-masterclass",
    isPast: false,
  },
  {
    id: 2,
    title_en: "Neurodiversity in Early Years Webinar",
    title_ar: "ندوة التنوع العصبي في الطفولة المبكرة",
    date: "2025-05-10",
    location_en: "Virtual",
    location_ar: "افتراضي",
    desc_en:
      "A free Zoom webinar for parents & nursery teachers on supporting SEN toddlers.",
    desc_ar:
      "ندوة مجانية عبر زوم للآباء ومعلمي الحضانات حول دعم الأطفال ذوي الاحتياجات.",
    registerLink: null,
    isPast: true,
  },
];
